import { getAPIBaseURL } from './helpers'
import { getData, postData, updateData, deleteData } from './request'

const base = () => `${getAPIBaseURL()}/v1`

const getAuthHeaders = () => {
  const token = localStorage.getItem('token')
  return token ? { 'token': token } : {}
}

const createUrlSearchParams = (payload) => {
  const params = new URLSearchParams()
  Object.keys(payload).forEach(key => {
    if (payload[key] !== undefined && payload[key] !== null && payload[key] !== '') {
      if (Array.isArray(payload[key])) {
        // Handle arrays (like discounts)
        if (key === 'discounts' && payload[key].length > 0) {
          payload[key].forEach((discount, index) => {
            params.append(`discounts[${index}].type`, discount.type)
            params.append(`discounts[${index}].value`, discount.value)
            if (discount.expiresAt) params.append(`discounts[${index}].expiresAt`, discount.expiresAt)
          })
        } else {
          payload[key].forEach(item => params.append(`${key}[]`, item))
        }
      } else if (typeof payload[key] === 'object' && payload[key] !== null) {
        // Handle nested objects (like salesWindow)
        Object.keys(payload[key]).forEach(subKey => {
          params.append(`${key}.${subKey}`, payload[key][subKey])
        })
      } else {
        params.append(key, payload[key])
      }
    }
  })
  return params.toString()
}

export const listTicketTypes = async (eventId) => {
  const url = `${base()}/events/${eventId}/ticket-types`
  const res = await getData(url, {}, {})
  if (res.error === '') {
    return { status: res.result.status, data: res.result.data.data || res.result.data }
  }
  return { status: res.result?.status || 500, error: res.result?.data }
}

export const listCenterTicketTypes = async () => {
  const url = `${base()}/center/ticket-types`
  const headers = getAuthHeaders()
  const res = await getData(url, headers, {})
  if (res.error === '') {
    return { status: res.result.status, data: res.result.data.data || res.result.data }
  }
  return { status: res.result?.status || 500, error: res.result?.data?.data || res.result?.data?.message }
}

export const addTicketType = async (payload) => {
  const url = `${base()}/ticket-types`
  const headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
    ...getAuthHeaders()
  }
  const params = createUrlSearchParams(payload)
  const res = await postData(url, headers, params)
  if (res.error === '') {
    return { status: res.result.status, data: res.result.data.data || res.result.data }
  }
  return { status: res.result?.status || 500, error: res.result?.data?.data || res.result?.data?.message }
}

export const updateTicketType = async (payload) => {
  const url = `${base()}/ticket-types`
  const headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
    ...getAuthHeaders()
  }
  const params = createUrlSearchParams(payload)
  const res = await updateData(url, headers, params)
  if (res.error === '') {
    return { status: res.result.status, data: res.result.data.data || res.result.data }
  }
  return { status: res.result?.status || 500, error: res.result?.data?.data || res.result?.data?.message }
}

export const deleteTicketType = async (ticketTypeId) => {
  const url = `${base()}/ticket-types/${ticketTypeId}`
  const headers = getAuthHeaders()
  const res = await deleteData(url, headers)
  if (res.error === '') {
    return { status: res.result.status, data: res.result.data.data || res.result.data }
  }
  return { status: res.result?.status || 500, error: res.result?.data?.data || res.result?.data?.message }
}

